import React from 'react';
import { useMutation } from '@apollo/client';
import InitiateWearableConnectionMutation from './InitiateWearableConnectionMutation';
import WearableConnectionsQuery from '../Fetch/WearableConnectionsQuery';

interface InitiateConnectionResult {
  code: string;
  authorizationUrl?: string;
  name?: string;
  description?: string;
}

interface Result {
  initiateConnection: (
    providerKey: string,
    redirectUri: string
  ) => Promise<InitiateConnectionResult | null>;
  loading: boolean;
}

interface Props {
  children: (result: Result) => React.ReactElement;
}

const InitiateWearableConnectionConnectorApollo: React.FC<Props> = ({ children }) => {
  const [mutate, { loading }] = useMutation(InitiateWearableConnectionMutation, {
    refetchQueries: [{ query: WearableConnectionsQuery }],
  });

  const initiateConnection = async (
    providerKey: string,
    redirectUri: string
  ): Promise<InitiateConnectionResult | null> => {
    const response = await mutate({ variables: { provider: providerKey, redirectUri } });
    return response.data?.wearable?.initiateConnection ?? null;
  };

  return children({ initiateConnection, loading });
};

export default InitiateWearableConnectionConnectorApollo;
